<app-card class="full-height">
  <div class="folder-header">
    <div>
      <mat-icon class="folder-icon">folder</mat-icon>
    </div>
    <div>
      <app-folder-actions-menu (onFolderEdit)="onEdit()"
                               (onFolderDelete)="onDeleted()"></app-folder-actions-menu>
    </div>
  </div>
  <div class="display-flex flex-align-center gap-0-5em overflow-hidden">
    <div class="folder-name text-ellipsis"
         [@enlargeText]="{
            value: enlargeText,
            params: {
              fontWeight: 500,
              fontSize: '1rem',
              enlargeFontWeight: 700,
              enlargeFontSize: '1.05rem'
            }
          }">{{ folder.name$ | async }}</div>
    <mat-icon class="material-icons-outlined info-icon"
              customToolTip
              [contentTemplate]="tooltip"
              *ngIf="(folder.folderCount$ | async) || (folder.reportCount$ | async)">info</mat-icon>
  </div>
  <div class="folder-info">
    <div>{{ folder.totalFolderCount$ | async }} folder.s</div>
    <div>{{ folder.totalReportCount$ | async }} report.s</div>
  </div>
  <ng-template #tooltip>
    <app-folder-selector-dialog-folder-tooltip [folder]="folder"></app-folder-selector-dialog-folder-tooltip>
  </ng-template>
</app-card>
